import classes from "./Home.module.scss";
import { Spacer, Text } from "@chakra-ui/react";
import { Heading, Box, Container } from "@chakra-ui/react";

type StyledTextProps = {
  children: string;
};

const StyledText = ({ children }: StyledTextProps) => {
  return (
    <Text color="lp_grey.500" as="p" fontSize="md" fontWeight="normal">
      {children}
    </Text>
  );
};

const Home = () => {
  return (
    <Container
      className={classes.homeText}
      id="home-expand"
      zIndex={1}
      position="relative"
      maxW="100%"
      centerContent
      backgroundColor="lp_grey.100"
      color="lp_grey.500"
    >
      <Box maxW={1200}>
        <div className={classes.title}>
          <Heading
            className={classes.livets}
            fontSize={{ base: "4xl", md: "6xl" }}
            fontWeight="thin"
          >
            LIVETS
          </Heading>
          <Heading
            className={classes.pussel}
            fontSize={{ base: "4xl", md: "6xl" }}
          >
            PUSSEL
          </Heading>
        </div>
        <StyledText>
          Dagens utbildningssystem är i grunden utformat för att lära unga att anpassa sig till den rådande världsordningen, snarare än att ge dem verktyg att förändra den. Systemet fokuserar på att förmedla kunskap som hjälper individer att fungera inom existerande strukturer, men inte nödvändigtvis att ifrågasätta eller förbättra dem. Problemet är att vi lever i en värld där förändring sker snabbare än någonsin. Tidigare självklara samarbeten mellan människor och nationer försvagas, och samhället står inför alltmer komplexa utmaningar. Ändå fortsätter utbildningen att vara fragmenterad – ämnen lärs ut separat utan tydliga kopplingar, vilket gör att unga ofta upplever sin utbildning som en samling lösryckta pusselbitar. Det leder till brist på motivation, handlingskraft och en känsla av meningsfullhet. Om utbildningens mål är att bygga en bättre värld, måste den förändras i grunden. Istället för att bara förbereda unga för att passa in i dagens samhälle, måste vi ge dem verktyg att aktivt forma framtiden. De behöver en utbildning som stärker deras förmåga att tänka holistiskt, samarbeta och ta ansvar för både sin egen och samhällets utveckling.
        </StyledText>
        <Spacer h={4} />
        <StyledText>
          För att möta denna utmaning har vi startat en ideell förening som främjar en integrerad och helhetsbaserad utbildning. Genom att koppla samman kunskap och hjälpa unga att utveckla en vision för sina liv, skapar vi en utbildningsmodell där lärande inte bara handlar om att samla information, utan om att förstå, agera och förändra. Vi tror att utbildningens främsta mål är att bygga en fredlig värld och att stärka individer så att de blir aktiva förändringsaktörer. Vår vision är att inspirera framtida ledare – människor som inte bara anpassar sig till världen, utan som aktivt arbetar för att förbättra den.
        </StyledText>
        <Spacer h={12} />

        <Heading
          className={classes.livets}
          fontSize={{ base: "2xl", md: "4xl" }}
          fontWeight="thin"
        >
          SAMHÄLLSBYGGANDE I SKOLAN
        </Heading>
        <Spacer h={4} />
        <StyledText>
          - Hur kan vi inspirera och stödja våra elever i att se sig själv som aktiva förändringsaktörer som bidrar till en bättre värld?
        </StyledText>
        <Spacer h={4} />
        <StyledText>
          - Hur kan vi stödja elever i att uppnå ett hållbart välbefinnande som omfattar fysisk, mental, emotionell och existentiell hälsa?
        </StyledText>
        <Spacer h={4} />
        <StyledText>
          - Hur kan vi samarbeta med elevernas familjer för att stärka deras lärande och välbefinnande?
        </StyledText>
        <Spacer h={4} />
        <StyledText>
          Dessa, och många andra aktuella frågor om viktiga aspekter av skolans uppdrag, leder oss att tänka på våra attityder och perspektiv när det gäller utbildning, undervisningsmetoder och praktiska strategier. Varje skola och klass kan ses som en potentiell övningsarena för skapandet av ett idealiskt mänskligt samhälle, ett miniatyrsamhälle där alla involverade har möjlighet att lära sig nya relationsmönster och samarbetsformer. För att möjliggöra detta krävs en förnyad självbild hos eleverna där varje individ kan betraktas som en gruva av värdefulla ädelstenar, i form av mänskliga dygder, talanger och intressen, som måste upptäckas, putsas och tas till vara för det gemensamma bästa. Genom meningsfulla projekt i närsamhället uppmuntras eleverna att hitta lösningar på problem baserat på deras nyfikenhet och kreativitet. Genom att kombinera vetenskaplig kunskap och stimulera till existentiella och etiska ställningstaganden rustas eleverna till att bli aktiva aktörer för sitt eget lärande samt sitt närsamhälle.
        </StyledText>
      </Box>
    </Container >
  );
};

export default Home;
